import {
    getMethod,
    postMethod,
    putMethod,
    deleteMethod
} from "../../api-service/api-service";

import {
    setOffices,
    setSelectedOffice,
    addOffice,
    updateOffice as updateOfficeReducer,
    removeOffice as removeOfficeReducer
} from "./officeSlice";

/**
 * GET ALL
 */
export const fetchAllOfficeAction = () => async (dispatch) => {
    const res = await getMethod('/office');
    if (res?.success) dispatch(setOffices(res.data));
    return res;
};

/**
 * GET DETAILS
 */
export const fetchOfficeDetailsAction = (id) => async (dispatch) => {
    const res = await getMethod(`/office/${id}`);
    if (res?.success) dispatch(setSelectedOffice(res.data));
    return res;
};

/**
 * CREATE
 */
export const createOfficeAction = (data) => async (dispatch) => {
    const res = await postMethod('/office', data);
    if (res?.success) dispatch(addOffice(res.data));
    return res;
};

/**
 * UPDATE
 */
export const updateOfficeAction = (id, data) => async (dispatch) => {
    const res = await putMethod(`/office/${id}`, data);
    if (res?.success) dispatch(updateOfficeReducer(res.data));
    return res;
};

/**
 * DELETE
 */
export const removeOfficeAction = (id) => async (dispatch) => {
    const res = await deleteMethod(`/office/${id}`);
    if (res?.success) dispatch(removeOfficeReducer(id));
    return res;
};